<template>
    <div class="c-comment__wrap">
        <div class="c-comments__comment" v-if="typeof comment != 'undefined'">
            <img
                class="c-comments__img"
                :src="comment.user_avatar"
                :alt="comment.user_name"
            />
            <div class="c-comments__content">
                <div class="c-comments__user">
                    <p>
                        <a :href="'/u/' + comment.user_name">{{
                            comment.user_name
                        }}</a>
                    </p>
                    <p>{{ comment.comment_created }}</p>
                </div>
                <p
                    class="u-m-t1 u-m-b1 c-comments__text"
                    v-html="comment.comment_text"
                ></p>
                <p class="u-m-t1 u-m-b3" v-if="comment.comment_image !== ''">
                    <img
                        :src="comment.comment_image"
                        :alt="comment.user_name + 'comment'"
                    />
                </p>
                <div
                    class="c-comments__cta"
                    v-if="
                        typeof comment != 'undefined' &&
                        typeof comment.comment_id != 'undefined'
                    "
                >
                    <p>
                        <a
                            href="#"
                            @click.prevent="commentReply(comment.comment_id)"
                            >Reply</a
                        >
                    </p>
                    <div @click="saveCommentLike(comment.comment_id)">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="21"
                            viewBox="0 0 24 21"
                            fill="none"
                            :class="{ liked: userLiked > 0 }"
                        >
                            <path
                                d="M11.728 19.8376C11.29 19.5766 1 13.3538 1 6.76474C1 3.58612 3.62739 1 6.85673 1C9.02896 1 10.9907 2.18834 12 4.00725C13.0093 2.18834 14.971 1 17.1433 1C20.3726 1 23 3.58612 23 6.76474C23 13.3538 12.71 19.5755 12.272 19.8376L12 20L11.728 19.8376Z"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                        <p>{{ commentLikes }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showReplyBox">
            <comment-box :parent-id="comment.comment_id"></comment-box>
        </div>
        <div
            v-if="showViewMore && showAllReplies === false"
            class="replies_outer u-m-b4"
        >
            <a
                href="#"
                class="u-block u-p-t1"
                @click.prevent="showReplies(comment.comment_id)"
                >View {{ comment.reply_count }} replies to this
                comment&#8230;</a
            >
        </div>
        <div v-if="showAllReplies">
            <comment-replies
                v-for="reply in comment.replies"
                :key="reply.comment_id"
                :reply="reply"
                :first_username="comment.user_name"
                :depth="0"
            ></comment-replies>
        </div>
    </div>
</template>

<script>
import CommentBox from "./CommentBox";
import CommentReplies from "./CommentReplies";

export default {
    components: {
        CommentBox,
        CommentReplies,
    },
    props: ["comment"],
    data() {
        return {
            replyCount: 0,
            userLiked:
                typeof this.comment != "undefined"
                    ? this.comment.user_liked
                    : 0,
            commentLikes:
                typeof this.comment != "undefined"
                    ? parseInt(this.comment.comment_likes) || 0
                    : 0,
            depth: 0,
            showReplyBox: false,
        };
    },
    created() {
        this.$root.$on("show-child-comments", (data) => {
            console.log("show-child-comments", this.comment.replies);
            this.showReplyBox = false;
            this.showAllReplies = true;
        });
    },
    computed: {
        showAllReplies() {
            return true;
            if (this.comment.reply_count === 1) {
                return true;
            }
            return false;
        },
        showViewMore() {
            if (
                typeof this.comment != "undefined" &&
                typeof this.comment.reply_count != "undefined" &&
                this.comment.reply_count > 1
            ) {
                return true;
            }
            return false;
        },
    },
    methods: {
        saveCommentLike(commentId) {
            let commentData = {
                commentId: commentId,
                communityId: this.$root.community.id,
            };
            this.$http.post("/post/like-comment", commentData).then(
                (response) => {
                    if (response.data.community_id === false) {
                        let modalData = {
                            cta: false,
                            message:
                                "You are currently not a member of this community - please join the community to like this comment",
                            communityId: this.$root.community.id,
                            communityName: this.$root.community.name,
                            communityThumbnail: this.$root.community.thumbnail,
                            title: "Join " + this.$root.community.name,
                        };
                        this.$root.$emit("bus-show-community-modal", modalData);
                    } else if (response.data.liked === true) {
                        this.commentLikes++;
                        this.userLiked = true;
                    } else if (response.data.liked === false) {
                        this.commentLikes--;
                        this.userLiked = false;
                    }
                },
                (response) => {
                    console.log("Errored:");
                    console.log(response);
                }
            );
        },
        commentReply(id) {
            this.showReplyBox = true;
        },
        showReplies(comment_id) {
            this.showAllReplies = true;
        },
    },
};
</script>
